import React from 'react';

export default () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.8335 18.9639L42.1948 30.75L23.8335 42.5361V18.9639Z" fill="currentColor" />
    <path d="M58.5187 30C58.5187 46.0239 45.6352 59 29.7594 59C13.8836 59 1 46.0239 1 30C1 13.9761 13.8836 1 29.7594 1C45.6352 1 58.5187 13.9761 58.5187 30Z" stroke="currentColor" strokeWidth="2" />
  </svg>
);
